import * as React from 'react';

export const ReportTypeContext = React.createContext(null);
